import { createSelector } from 'reselect';
import { initialState } from '../reducers/crmObjectEditingReducer';
// Basic selector to get the entire CRM object editing state
export const getCrmObjectEditing = createSelector([state => state.crmObjectEditing], crmObjectEditing => crmObjectEditing || initialState);
export const getCrmObjectSchemaAsCmv2Schema = createSelector([getCrmObjectEditing], crmObjectEditing => crmObjectEditing.fieldSchema);

// Selector to get the CRM objects to edit
export const getCrmObjectsToEdit = createSelector([getCrmObjectEditing], crmObjectEditing => crmObjectEditing.crmObjectByKey);

// Need to convert CRM object shape to basic format
// const fieldValues = {
//   quote: {
//     properties: {
//       hs_cover_letter: '<h1>foobar</h1>',
//     },
//   },
// };
export const getCrmObjectValuesAsFieldValues = createSelector([getCrmObjectSchemaAsCmv2Schema, getCrmObjectsToEdit], (crmObjectSchemaAsCmv2Schema, crmObjectsToEdit) => {
  if (!crmObjectSchemaAsCmv2Schema || !crmObjectsToEdit) {
    return {};
  }
  const result = {};

  // Helper function to traverse the schema and build result object
  const traverseCmv2Schema = (schema, parentPath = [], targetObj = result) => {
    schema.forEach(field => {
      const currentPath = [...parentPath, field.name];
      if (field.type === 'group' && field.children) {
        // For group type, create a nested object and process children
        const groupObj = {};
        targetObj[field.name] = groupObj;
        traverseCmv2Schema(field.children, currentPath, groupObj);
      } else {
        // For leaf fields, extract the value from crmObjectsToEdit
        let value = crmObjectsToEdit;
        for (const key of currentPath) {
          if (!value || typeof value !== 'object') {
            value = undefined;
            break;
          }
          value = value[key];
        }

        // Add .value to access the actual value
        if (value !== undefined && value !== null && 'value' in value) {
          targetObj[field.name] = value.value;
        }
      }
    });
  };

  // Start traversal with the root schema
  Object.entries(crmObjectSchemaAsCmv2Schema).forEach(([key, schema]) => {
    if (Array.isArray(schema)) {
      result[key] = {};
      traverseCmv2Schema(schema, [key], result[key]);
    }
  });
  return result;
});